/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getOverviewList = (params) => makeApiCall(`/product-sample-plan`, 'GET', params);

export const getOverviewSummaryList = (params) =>
  makeApiCall(`/product-sample-plan/overview-summary`, 'GET', params);

export const postCreatePlan = (params) => makeApiCall(`/product-sample-plan`, 'POST', params);

export const getSamplingPlanView = (params) =>
  makeApiCall(`/product-sample-plan/plan-item`, 'GET', params);

export const getProducts = (params) => makeApiCall(`/products/list`, 'POST', params);

export const getSegments = (params) => makeApiCall(`/products/product-segments`, 'GET', params);

export const postUpdatePlan = (params) => makeApiCall(`/product-sample-plan`, 'POST', params);

export const postPlanConfirmation = (params) =>
  makeApiCall(`/product-sample-plan/confirmation`, 'POST', params);

export const getCategories = (params) => makeApiCall(`/products/sample-category`, 'GET', params);

export const getWarehousePrepers = (params) =>
  makeApiCall(`/user/warehouse/prepers`, 'GET', params);

export const getWarehouseDispatchers = (params) =>
  makeApiCall(`/user/warehouse/dispatchers`, 'GET', params);

export const getProductConfirmedInventory = (params) =>
  makeApiCall(`/product-sample-plan/confirmed-inventory`, 'POST', params);

export const getCalendarPlanCount = (params) =>
  makeApiCall(`/product-sample-plan/effectivity-month-count`, 'POST', params);

//  ALLOCATION
export const postProductAllocationTemplateImport = (params) =>
  makeApiCall(`/product-allocation-maintenance/template/import`, 'POST', params, true);

export const postProductAllocationTemplateExport = (params) =>
  makeApiCall(`/product-allocation-maintenance/template/export`, 'POST', params);

export const postFinalizeAllocation = (params) =>
  makeApiCall(`/product-sample-plan/finalize`, 'POST', params);

// MONITORING

export const getPlanDetails = (params) =>
  makeApiCall(`/product-sample-plan/status-monitoring/plan-detail`, 'POST', params);

export const getFinalizeListPlan = (params) =>
  makeApiCall(`/product-sample-plan/status-monitoring/plan`, 'POST', params);

export const getDeliveryStatusList = (params) =>
  makeApiCall(`/product-sample-plan/delivery-statuses`, 'GET', params);

export const postDeliveryImport = (params) =>
  makeApiCall(`/product-sample-plan/status-monitoring/plan-detail-import`, 'POST', params, true);

export const postDeliveryExport = (params) =>
  makeApiCall(`/product-sample-plan/status-monitoring/plan-detail-export`, 'POST', params);
